import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useTranslation();
  const h = t.hero;

  return (
    <section
      id="hero"
      className="min-h-screen flex flex-col justify-center relative pt-24 pb-16 bg-[#0A0A0B]"
      data-testid="hero-section"
    >
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-[#C9A96E]/5 blur-[150px] rounded-full pointer-events-none" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center">
        {/* Eyebrow — first in sequence */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0 }}
          className="mb-10"
        >
          <span className="fwd-eyebrow" data-testid="hero-eyebrow">
            {h.eyebrow}
          </span>
        </motion.div>

        {/* Headline — Display size */}
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="fwd-display mb-10"
          data-testid="hero-headline"
        >
          {h.headlineLead}{" "}
          <span className="fwd-italic-gold">{h.headlineItalic}</span>
        </motion.h1>

        {/* Subheadline — Body size, max 640px */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="fwd-body mx-auto mb-12"
          style={{ maxWidth: "640px" }}
          data-testid="hero-body"
        >
          {h.body}
        </motion.p>

        {/* Button — last in sequence */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.45 }}
          className="flex justify-center"
        >
          <a href="#contact" className="fwd-button" data-testid="hero-cta-primary">
            {h.cta}
            <ArrowRight size={18} className="fwd-arrow" />
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span
          className="text-[13px] uppercase text-[#B8B8C0]"
          style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 600, letterSpacing: "0.22em" }}
        >
          {h.scroll}
        </span>
        <motion.div animate={{ y: [0, 6, 0] }} transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}>
          <ArrowDown size={20} className="text-[#B8B8C0]" />
        </motion.div>
      </motion.div>
    </section>
  );
}
